export default __webpack_public_path__ + "static/media/Jan_Headshot.64255dab.jpg";